export default __webpack_public_path__ + "static/media/gogreenLogo.d6ae05d9.svg";